import React, { useState, useEffect } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { Autocomplete, TextField, createFilterOptions } from "@mui/material";
import ClipLoader from "react-spinners/ClipLoader";
import axios from "axios";
import { useDebounce } from "use-debounce";
import { TextInputLabel } from "./AttendentList.styled";
import UserInfo from "@utils/UserInfo";

const AttendentList = (props) => {
  const { t, formData, setFormData, isEditMode, countryId } = props;

  const [selectedAdmins, setSelectedAdmins] = useState([]);
  const [adminList, setAdminList] = useState([]);
  const [isAdminSuggestionsLoading, setAdminSuggestionsLoading] =
    useState(false);
  const [query, setQuery] = useState();
  const [debounceQuery] = useDebounce(query, 700);

  useEffect(() => {
    setFormData({
      ...formData,
      attendees: {
        value: selectedAdmins,
        error: "",
        required: true,
      },
    });
  }, [selectedAdmins]);

  useEffect(() => {
    if (!isEditMode) {
      // Get admin ID from localStorage (JWT auth)
      const user = UserInfo.getUser();
      const adminId = user?.id;
      if (adminId && countryId) {
        let url = `/general/search?objectId=${adminId}&limit=10&countries=[${countryId}]&objectTypes=["admin"]`;
        getAdmins(url, "selectedDefault");
      }
    } else {
      let attendeeList = [];
      formData.attendees?.value.map((key) => {
        attendeeList.push({
          id: key.id,
          name: key.firstName + " " + key.lastName,
        });
      });
      setSelectedAdmins(attendeeList);
    }
  }, []);

  const handleChange = (e) => {
    setQuery(e.target.value || undefined);
  };

  useEffect(() => {
    searchAdmin();
  }, [debounceQuery]);

  const searchAdmin = () => {
    const search = query;
    if (search) {
      let url = `/general/search?search=${search}&limit=10&countries=[${countryId}]&objectTypes=["admin"]`;
      getAdmins(url, "all");
    }
  };

  const getAdmins = (url, type) => {
    setAdminSuggestionsLoading(true);
    axios
      .get(url)
      .then((response) => {
        // Map admins to include name field for Autocomplete
        const adminsWithName = response.data.admins.map((admin) => ({
          ...admin,
          name: `${admin.firstName || ""} ${admin.lastName || ""}`.trim(),
        }));
        setAdminList(adminsWithName);
        setAdminSuggestionsLoading(false);
        if (type === "selectedDefault" && adminsWithName[0]) {
          setSelectedAdmins([adminsWithName[0]]);
        }
      })
      .catch((error) => {
        if (window.debugMode) {
          console.error(
            "Error: an error occurred while fetching admins",
            error
          );
        }
        setAdminList([]);
        setAdminSuggestionsLoading(false);
      });
  };

  return (
    <>
      <TextInputLabel>
        {" "}
        {t("HESUS_PARTICIPANTS")}
        {isAdminSuggestionsLoading && (
          <ClipLoader size={15} background="#15aee5 !important" />
        )}
      </TextInputLabel>
      <Autocomplete
        multiple
        id="tags-outlined"
        options={adminList}
        getOptionLabel={(option) => option?.name || ""}
        style={{ zIndex: 99 }}
        filterSelectedOptions
        renderInput={(params) => <TextField {...params} placeholder="" />}
        value={selectedAdmins}
        onKeyUp={handleChange}
        onChange={(event, newValue) => {
          // Check if 'All' option is clicked
          if (newValue.find((option) => option.id === 0)) {
            // Check if all options are selected
            if (usersOptions.length === selectedAdmins.length) {
              setSelectedAdmins([]);
            } else {
              setSelectedAdmins(usersOptions);
            }
          } else {
            setSelectedAdmins(newValue);
          }
        }}
        // Add These props
        isOptionEqualToValue={(option, value) => option.id === value.id}
        filterOptions={(options, params) => {
          const filtered = createFilterOptions()(options, params);
          return [...filtered];
        }}
      />
    </>
  );
};

AttendentList.propTypes = {
  t: PropTypes.func.isRequired,
  isEditMode: PropTypes.bool,
};
AttendentList.defaultProps = {
  isEditMode: false,
};
export default withTranslation()(AttendentList);
